import { HGIntervalType } from "./types";
import { QuickIntervalTarget } from "./quickIntervals";
import { ConvertInterval } from "@/engine/engine";
import { countN } from "./intervals";
import { getMaxN } from "./intervalTypes";

// Coarse -> fine, main chain only, so the result is always reachable by
// HGStack.setInterval() from any current position.
const FIT_CHAIN: HGIntervalType[] = [
  "byr",
  "myr",
  "kyr",
  "c",
  // "dec",
  "y",
  "m",
  "d",
  "h",
  "min",
  "s",
];

// How many rows the widened range may span at the finest level we pick:
// coarser than that and the list becomes unusable, finer and it's just noise.
const MAX_STEPS = 200;

/**
 * Finds the finest interval type at which [minSecond, maxSecond] still spans
 * at most MAX_STEPS ticks, and returns the interval pair covering it.
 * Returns null only if the chain is empty, which cannot happen.
 */
export function fitIntervalsToSeconds(
  minSecond: bigint,
  maxSecond: bigint,
): QuickIntervalTarget | null {
  let best: QuickIntervalTarget | null = null;

  for (const it of FIT_CHAIN) {
    let from = ConvertInterval({ n: minSecond, it: "s" }, it).n;
    let to = ConvertInterval({ n: maxSecond, it: "s" }, it).n;

    const maxN = getMaxN(it);
    if (maxN !== undefined) {
      if (from < -maxN) from = -maxN;
      if (to > maxN) to = maxN;
    }

    if (best && countN(from, to) > MAX_STEPS) break;

    best = {
      interval: { n: from, it },
      endInterval: from === to ? null : { n: to, it },
    };
  }

  return best;
}
